import React, { SyntheticEvent, useMemo } from 'react';
import Box from '@mui/material/Box';
import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import { SearchTabsWrapper } from './styles';

export interface SearchTabItem {
  value: string;
  label: string;
  hidden?: boolean;
  disabled?: boolean;
}

export interface SearchTabsProps {
  value: string;
  items: SearchTabItem[];
  onChange: (event: SyntheticEvent, newValue: string) => void;
}

const SearchTabs = ({ value, items, onChange }: SearchTabsProps) => {
  const visibleItems = useMemo(() => items.filter(item => !item.hidden), [items]);

  if (visibleItems.length === 0) {
    return null;
  }

  return (
    <SearchTabsWrapper id="sr">
      <Box sx={{ height: '72px', width: '100%', typography: 'body1' }}>
        <TabContext value={value}>
          <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
            <TabList variant="scrollable" scrollButtons="auto" onChange={onChange} aria-label="search results">
              {visibleItems.map(tab => (
                <Tab key={tab.value} label={tab.label} value={tab.value} disabled={tab.disabled} />
              ))}
            </TabList>
          </Box>
        </TabContext>
      </Box>
    </SearchTabsWrapper>
  );
};

export default SearchTabs;
